import { BasicInfoSection } from '../components/basic-info-section';
import { DisplayPreferencesSection } from '../components/display-preferences-section';
import { MultiFactorAuthSection } from '../components/multi-factor-auth-section';
import { ResetPasswordSection } from '../components/reset-password-section';

export function UserPreferencesPage() {
  return (
    <div
      data-testid="user-preferences-page"
      className="mx-auto max-w-4xl space-y-6 p-6"
    >
      <div className="space-y-2">
        <h1 className="text-balance text-3xl font-bold">User Preferences</h1>
        <p className="text-muted-foreground">
          Manage your account settings and preferences
        </p>
      </div>

      <BasicInfoSection />
      <ResetPasswordSection />
      <MultiFactorAuthSection />
      <DisplayPreferencesSection />
    </div>
  );
}
